/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 11/8/20
 * Time: 7:25 PM
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actionCreator from "../../../../store/Action";
import '../CreateLocation/style.css'
import Download from '../../../../components/Button/DownloadbleButton'

import {Button, Card, CardBody, CardHeader} from 'reactstrap';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from 'mdbreact'
import {Button as SementicBtn, Dropdown} from 'semantic-ui-react'
import {Icon, Spin} from "antd";
import FloorUpdate from "../ViewAll/FloorUpdate/FloorUpdate";
import BuildingUpdate from "../ViewAll/BuildingUpdate/BuildingUpdate";
import CreateBuilding from "../CreateLocation/index";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
// import MapView from "../../Branches/MapView/MapView";
import {geocodeByAddress, getLatLng} from "react-places-autocomplete";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";

class App extends Component {

  state = {
    floor_modal: false,
    building_modal: false,
    floors_list: [],branch_list:[],branch_dropdown_list:[],filter_branch: 0,
    building_id: 0,
    building_obj: null,
    isSpin: false,
    building_list: [],
    isMap:false,
    location_:'',
    latLng: null,
    isCreate:false,
    tempBranchId: 0,
    selectedBuilding:0,
  };

  modalHandler = (state_name, condition) => {
    this.setState({
      [state_name]: condition
    })
  };

  viewFloor = (list,buildingId) => {
    this.setState({
      floors_list: list,
      selectedBuilding: buildingId
    });

    this.modalHandler("floor_modal", true);
  };
  getAllLocations = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.changeSpinner(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branchList = response.data.branchList;
          this.settleBranchesUsingBranchId(branchList,0)
        } else {
          this.setState({building_list: []});
          //  dashboard single type
          this.props.addTagsDashboardSingle("buildingsCount",0);
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllLocations()
        }
      })
      .finally(fin => {
        this.changeSpinner(false);
      });

  };
  settleBranchesUsingBranchId = (branchList,id) => {
    let building_list = [];
    let branch_dropdown_list = [];
    branch_dropdown_list.push({key: 0,text: "All branch", value: 0});

    if(branchList === null) branchList = this.state.branch_list;
    if (branchList.length !== 0) {
      branchList.map((branch, index) => {
        if((branch.branchId === id) || id === 0){
          if (branch.buildings.length !== 0) {
            branch.buildings.map((building, buildIndex) => {

              const obj = {
                branchId: branch.branchId,
                buildingId: building.buildingId,
                code: building.code,
                floors: building.floors,
                levelCount: building.levelCount,
                name: building.name,
                branch: branch.name,
                status: building.status,
              };
              building_list.push(obj)
            })
          }
        }
        if(branchList){
          branch_dropdown_list.push({key: index,text: branch.name, value: branch.branchId})
        }
      })
    }
    this.setState({
      building_list: building_list,filter_branch: id,branch_dropdown_list
    });
    if(branchList) this.setState({branch_list: branchList});
    //  dashboard single type
    this.props.addTagsDashboardSingle("buildingsCount",building_list.length !== 0 ? 1 : 0);
  };
  updateLocation = (obj) => {
    this.setState({
      building_obj: obj,  building_modal: true
    })
  };
  deleteLocation_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_BRANCH_BUILDING_DELETE(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Floor details successfully deleted", 0);
          this.getAllLocations();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteLocation_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteLocation = (buildingId,name) => {
    swal({
      title:"Do you want to delete this building? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if(value === name){
          this.deleteLocation_(buildingId)
        }else{
          common.warningAlert("Can't delete building", 1)
        }
      });

  };
  tableButtonClick = (e, type, index,buildingId) => {

    switch (type) {
      case 'updateLocation':
        this.updateLocation(index);
        break;
      case 'deleteLocation':
        this.deleteLocation(index,buildingId); // buildingId,buildingName
        break;
      case 'viewFloor':
        this.viewFloor(index,buildingId);
        break;
      case 'updateFloor':
        this.updateFloor(index);
        break;
      case 'deleteFloor':
        this.deleteFloor(index);
        break;

      case 'viewLocation':
        geocodeByAddress(index)
          .then(results => getLatLng(results[0]))
          .then(latLng => this.setState(
            {latLng: latLng, isMap: true, location_: index}
          ))
          .catch(error => common.notifyMessage(error));
        break;

      default:
        break;
    }
  };

  changeSpinner = (condition) => {
    this.setState({
      isSpin: condition
    })
  };

  componentDidMount() {
    let branchId = this.props.location.state;
    if (branchId) {
      this.setState({tempBranchId: parseInt(branchId),isCreate: true})
    }
    this.getAllLocations();
  };

  viewMap = () => {
    this.setState({
      isMap: !this.state.isMap,
    })
  };

  render() {
    let {isCreate,tempBranchId} = this.state;

    const rows = [];
    if(this.state.building_list.length !== 0){
      this.state.building_list.map((row, index) => {
        rows.push(
          {
            building: row.name,
            branch: row.branch,
            // view:<SementicBtn icon='map marker alternate' circular color='teal'
            //                   onClick={e => this.tableButtonClick(e, 'viewLocation', row.location)}/>,
            // code: row.code,
            level: row.levelCount,
            status: row.status,
            floor:
              <SementicBtn icon='eye' circular color={"linkedin"}
                           onClick={e => this.tableButtonClick(e, 'viewFloor', row.floors,row.buildingId)}/>,

            action:
              <div>
                <SementicBtn circular icon='edit' onClick={e => this.tableButtonClick(e, 'updateLocation', row)}/>
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={e => this.tableButtonClick(e, 'deleteLocation', row.buildingId,row.name)}/>
              </div>
          }
        )
      });
    }

    let columns = this.props.viewAllTable_data.manage_building_columns;
    let table_data = {columns, rows};

    return (
      <div className={"manage-building-wrapper"}>
        <div style={{marginBottom: '1rem'}}>
          {tempBranchId !== 0 && <div className={"float-left"}>
            <Button className="submit-btn ppx-5" color={"red"} onClick={()=>this.props.history.push(`/corporate/branch`)}>
              <i className="fa fa-caret-left mr-2"/> Go to 'Manage Branches'</Button>
          </div>}
          <div className={"align-right"}>
            <SementicBtn className="px-5" onClick={()=>this.setState({isCreate:true})}>Create</SementicBtn>
          </div>
        </div>

        <Card>
          {/*{*/}
            {/*this.state.isMap ?*/}
              {/*<MapView location={this.state.location_} latLng={this.state.latLng} closeModal={this.viewMap}/> : null*/}
          {/*}*/}
          {
            isCreate ?
              <MDBModal className={"create-building-modal"} isOpen={true} toggle={()=>{}} size={"lg"}>
                <MDBModalHeader toggle={()=>this.setState({isCreate:false})}>{"Create Building"}</MDBModalHeader>
                <MDBModalBody>
                  <CreateBuilding closeModal={()=>this.modalHandler("isCreate",false)} refreshData={this.getAllLocations} tempBranchId={tempBranchId} parent={true} />
                </MDBModalBody>
              </MDBModal>
              :null
          }
          {
            this.state.floor_modal ?
              <FloorUpdate buildingId={this.state.selectedBuilding} closeModal={this.modalHandler} floors_list={this.state.floors_list} refreshData={this.getAllLocations}/> : null
          }
          {
            this.state.building_modal ?
              <BuildingUpdate data={this.state.building_obj} closeModal={this.modalHandler} refreshData={this.getAllLocations}/> : null
          }

          <CardHeader>
            View All Buildings
            <div className={"status-wrapper"}>
              <Dropdown
                fluid selection search={true}
                options={this.state.branch_dropdown_list} value={this.state.filter_branch}
                onChange={(event, {value}) => {
                  this.settleBranchesUsingBranchId(null, value)
                }}
              />
            </div>
            <Download data={this.state.building_list} filename={"all-buildings.csv"} userType={"MANAGE_BUILDINGS"}/>
          </CardHeader>
          <CardBody>
            <Spin spinning={this.state.isSpin} delay={10}
                  indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
              <MDBDataTable
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  viewAllTable_data: state.COPLocationReducer.viewAllTable_data,
  floorViewTable_data: state.COPLocationReducer.floorViewTable_data,
  floors: state.COPLocationReducer.floors,
  locations: state.COPLocationReducer.locations,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getFloor: (data) => dispatch(actionCreator.getFloor(data)),
    getAllLocations: (data) => dispatch(actionCreator.getAllLocations(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard single value handler
    addTagsDashboardSingle: (type,data) => dispatch(actionCreator.addTagsDashboardSingle(type,data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
